import React, { Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/UI/ErrorBoundary';
import Loader from './components/UI/Loader';
import Home from './pages/Home';

function App() {
    return (
        <ErrorBoundary>
            <div className="app">
                <main className="main-content">
                    <Suspense fallback={<Loader />}>
                        <Home />
                    </Suspense>
                </main>
            </div>
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 5000,
                    style: {
                        background: '#fff',
                        color: '#333',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                        borderRadius: '0.5rem',
                        padding: '1rem',
                    },
                    success: {
                        iconTheme: {
                            primary: '#22c55e',
                            secondary: '#fff',
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: '#ef4444',
                            secondary: '#fff',
                        },
                    },
                }}
            />
        </ErrorBoundary>
    );
}

export default App; 